import { EDuration } from '../type'

import type { TUseSubLog } from '@/contexts/SiteSpecificContext/hooks/subLog'


import { useMemo, useState, useEffect } from 'react';
export interface IUseDuration {
  plan: TUseSubLog
  onCurrentDurationChange?: (duration: EDuration) => void
}

export function useDuration({ plan, onCurrentDurationChange }: IUseDuration) {
  const { creditsPlanIsUnlimited, creditsPlan } = plan

  const defaultDuration = useMemo(() => {
    if (creditsPlanIsUnlimited) {
      return EDuration.YEARLY
    }
    return creditsPlan?.productsSub.duration || EDuration.YEARLY
  }, [creditsPlan?.productsSub.duration, creditsPlanIsUnlimited])

  const [curDuration, setCurDuration] = useState<EDuration>(defaultDuration)

  useEffect(() => {
    setCurDuration(defaultDuration)
  }, [defaultDuration])

  const toggleDuration = (duration: EDuration) => {
    setCurDuration(duration)
  }

  useEffect(() => {
    onCurrentDurationChange?.(curDuration)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curDuration])

  return {
    curDuration,
    toggleDuration,
  }
}

export type TUseDuration = ReturnType<typeof useDuration>
